var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
var MessagesRowComponent = /** @class */ (function () {
    function MessagesRowComponent(http, router) {
        this.http = http;
        this.router = router;
        this.changeOpened = new EventEmitter();
        this.inboundSettingsChanged = new EventEmitter();
        this.settingsChanged = new EventEmitter();
        this.settings = {
            voiceMailDrop: {}
        };
    }
    MessagesRowComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.url = {
            voiceMailDrop: "/outbound/configuration/numbers/" + this.msisdnId + "/voicemaildrop",
            welcomeMessage: "/inbound/configuration/numbers/" + this.msisdnId + "/receive/welcome-message",
            onHold: "/inbound/configuration/numbers/" + this.msisdnId + "/receive/hold-message",
            voiceMailNoAgents: "/inbound/configuration/numbers/" + this.msisdnId + "/receive/voicemail",
            promptNoAgents: "/inbound/configuration/numbers/" + this.msisdnId + "/receive/prompt",
            voiceMailDontReceive: "/inbound/configuration/numbers/" + this.msisdnId + "/dont-accept/voicemail",
            promptDontReceive: "/inbound/configuration/numbers/" + this.msisdnId + "/dont-accept/prompt"
        }[this.type];
        if (this.type === 'voiceMailDrop') {
            this.http.get("/outbound/configuration/numbers/" + this.msisdnId).subscribe(function (res) {
                _this.settings.voiceMailDrop = __assign({}, res);
            });
        }
    };
    Object.defineProperty(MessagesRowComponent.prototype, "receiveCallConfig", {
        get: function () {
            return this.numberConfig.receiveCallConfiguration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessagesRowComponent.prototype, "dontAcceptCallConfig", {
        get: function () {
            return this.numberConfig.dontAcceptCallConfiguration;
        },
        enumerable: true,
        configurable: true
    });
    MessagesRowComponent.prototype.refresh = function () {
        var _this = this;
        if (this.type === 'voiceMailDrop') {
            this.http.get("/outbound/configuration/numbers/" + this.msisdnId).subscribe(function (res) {
                _this.settings.voiceMailDrop = res;
                _this.settingsChanged.next(res);
            });
        }
        else {
            this.http.get("/inbound/configuration/numbers/" + this.msisdnId).subscribe(function (res) {
                _this.numberConfig.receiveCallConfiguration = res['receiveCallConfiguration'];
                _this.numberConfig.dontAcceptCallConfiguration = res['dontAcceptCallConfiguration'];
                _this.settingsChanged.next(res);
            });
        }
    };
    Object.defineProperty(MessagesRowComponent.prototype, "fileName", {
        get: function () {
            return {
                voiceMailDrop: this.settings.voiceMailDrop.voiceMailFilename,
                welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageFile,
                onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageFile,
                voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.voicemailMessageFile,
                promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.promptMessageFile,
                promptDontReceive: this.dontAcceptCallConfig.promptMessageFile,
                voiceMailDontReceive: this.dontAcceptCallConfig.voicemailMessageFile
            }[this.type];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessagesRowComponent.prototype, "bucketFileName", {
        get: function () {
            return {
                voiceMailDrop: this.settings.voiceMailDrop.voiceMailFilename,
                welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageFile,
                onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageFile,
                voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.voicemailMessageFile,
                promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.promptMessageFile,
                promptDontReceive: this.dontAcceptCallConfig.promptMessageFile,
                voiceMailDontReceive: this.dontAcceptCallConfig.voicemailMessageFile
            }[this.type];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessagesRowComponent.prototype, "isActive", {
        get: function () {
            return {
                voiceMailDrop: this.settings.voiceMailDrop.voiceMailDropEnabled || false,
                welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageEnabled || false,
                onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageEnabled || false,
                promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.strategy === 'PROMPT' || false,
                voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.strategy === 'VOICEMAIL' || false,
                promptDontReceive: this.dontAcceptCallConfig.strategy === 'PROMPT' || false,
                voiceMailDontReceive: this.dontAcceptCallConfig.strategy === 'VOICEMAIL' || false
            }[this.type];
        },
        enumerable: true,
        configurable: true
    });
    MessagesRowComponent.prototype.remove = function () {
        this.refresh();
    };
    MessagesRowComponent.prototype.changeActiveState = function (enabled) {
        var _this = this;
        if (this.type === 'voiceMailDrop') {
            this.http
                .post("/outbound/configuration/numbers/" + this.msisdnId + "/enable-voicemaildrop", {}, {
                params: {
                    enabled: enabled
                }
            })
                .subscribe(function (res) {
                _this.refresh();
            });
        }
        else if (this.type === 'welcomeMessage') {
            this.http
                .post("/inbound/configuration/numbers/" + this.msisdnId + "/receive/welcome-message/enable", {}, {
                params: {
                    enabled: enabled
                }
            })
                .subscribe(function () {
                _this.refresh();
            });
        }
        else if (this.type === 'onHold') {
            this.http
                .post("/inbound/configuration/numbers/" + this.msisdnId + "/receive/hold-message/enable", {}, {
                params: {
                    enabled: enabled
                }
            })
                .subscribe(function () {
                _this.refresh();
            });
        }
    };
    MessagesRowComponent.prototype.upgradeAccount = function () {
        this.router.navigateByUrl('/my-account');
    };
    return MessagesRowComponent;
}());
export { MessagesRowComponent };
